import { useMissionsTranslation } from '../../../../../../ui/hooks';
import CheckIcon from '@mui/icons-material/Check';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
export const Toolbar = ({ totalRequestsNumber, multiSelect, disableApproveButton, onApproveVolunteer }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { sx: {
            display: 'flex',
            pb: 2,
            alignItems: { xs: 'flex-start', md: 'center' },
            flexWrap: 'wrap',
            gap: 1,
        }, "data-test": 'pending-requests-toolbar' },
        React.createElement(Box, { display: 'flex', flexGrow: 1, gap: 1 },
            React.createElement(Box, { display: 'flex', alignItems: 'center', gap: 1 },
                React.createElement(TimelapseIcon, { sx: { color: (theme) => theme.palette.grey['700'] } }),
                React.createElement(Typography, { variant: 'subtitle2', sx: { color: (theme) => theme.palette.grey['900'] } }, t('missions.missionDetails.pendingRequests')),
                React.createElement(Typography, { variant: 'body2', sx: { color: (theme) => theme.palette.grey['700'] } }, t('missions.missionDetails.pendingRequestsCount', { pendingRequests: totalRequestsNumber }))),
            totalRequestsNumber > 0 && (React.createElement(Button, { size: 'small', onClick: multiSelect.handleSelectAllRows, "data-test": 'select-all-button' }, multiSelect.allItemsSelected ? t('common.unselectAll') : t('common.selectAll')))),
        React.createElement(Box, { sx: {
                display: 'flex',
                gap: 2,
                ml: 'auto',
                flexDirection: { xs: 'column', md: 'row' },
                width: { xs: '100%', md: 'auto' },
            } },
            React.createElement(Button, { sx: { width: { xs: '100%', sm: 'auto' } }, disabled: disableApproveButton, startIcon: React.createElement(CheckIcon, null), variant: 'outlined', onClick: onApproveVolunteer, "data-test": 'approve-all-button' }, t('missions.missionDetails.approvePendingRequest')))));
};
